import { render, staticRenderFns } from "./Addon.vue?vue&type=template&id=dd7d234a&scoped=true&"
import script from "./Addon.vue?vue&type=script&lang=js&"
export * from "./Addon.vue?vue&type=script&lang=js&"
import style0 from "./Addon.vue?vue&type=style&index=0&id=dd7d234a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7d234a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VForm,VIcon})
